package com.nonopn.skywatcher.common.api

import io.ktor.client.HttpClient
import io.ktor.client.request.bearerAuth
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

private var baseUrl = "https://api.lpsmanager.io"
private const val ALERTS_URL = "https://strikeradar.lpsplatform.com/alerts-settings.php"
private const val DOCUMENTS_HISTORY_URL = "https://strikeradar.lpsplatform.com/documents-history.php"

class ApiSession(
    // val baseUrl: String,
    client: HttpClient
) {
    private val calls = DoNetworkCalls(client)

    suspend fun profile(): APIUserSession = calls.get("$baseUrl/user")

    suspend fun changePassword(body: ChangePasswordRequest): ChangePasswordAnswer = calls.post(
        "$baseUrl/account/password",
        body
    )

    // Reads (empty request) or updates the email alert settings of the logged-in user.
    suspend fun alertSettings(
        token: String,
        request: AlertSettingsRequest = AlertSettingsRequest()
    ): AlertSettingsAnswer = manageAnswer(
        calls.client.post(ALERTS_URL) {
            bearerAuth(token)
            contentType(ContentType.Application.Json)
            setBody(request)
        }
    )

    // Reads the documents history of the account (no request), or merges the given items
    // into it. Both return the full history stored on the server.
    suspend fun documentsHistory(
        token: String,
        request: DocumentsHistoryRequest? = null
    ): DocumentsHistoryAnswer = if (null == request) {
        manageAnswer(
            calls.client.get(DOCUMENTS_HISTORY_URL) {
                bearerAuth(token)
            }
        )
    } else {
        manageAnswer(
            calls.client.post(DOCUMENTS_HISTORY_URL) {
                bearerAuth(token)
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        )
    }
}
